var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 13.0801C9 12.0192 9.42143 11.0018 10.1716 10.2517C10.9217 9.50151 11.9391 9.08008 13 9.08008L15 13.0801L13.46 15.3888C14.0709 16.8485 15.2316 18.0092 16.6912 18.6201L19 17.0801L23 19.0801C23 20.1409 22.5786 21.1584 21.8284 21.9085C21.0783 22.6586 20.0609 23.0801 19 23.0801C16.3478 23.0801 13.8043 22.0265 11.9289 20.1511C10.0536 18.2758 9 15.7322 9 13.0801Z",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99109 26.469C12.5118 27.9278 15.4769 28.4202 18.3338 27.8543C21.1907 27.2884 23.7443 25.7028 25.5184 23.3932C27.2926 21.0836 28.1663 18.2075 27.9766 15.3013C27.7869 12.3951 26.5467 9.65711 24.4873 7.59774C22.428 5.53837 19.6899 4.29822 16.7837 4.10851C13.8775 3.9188 11.0015 4.79247 8.69189 6.56664C6.38228 8.34081 4.7967 10.8944 4.23078 13.7513C3.66486 16.6081 4.15723 19.5733 5.61609 22.094L4.05234 26.7627C3.99358 26.9389 3.98505 27.128 4.02771 27.3088C4.07037 27.4896 4.16254 27.6549 4.29387 27.7862C4.42521 27.9175 4.59052 28.0097 4.77129 28.0524C4.95206 28.095 5.14114 28.0865 5.31734 28.0277L9.99109 26.469Z",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black",
    transform: "translate(0 0.0800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.713f7b0d77dd79110d7c888af18554f0.svg";
export { ForwardRef as ReactComponent };